/* eslint-disable no-undef */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import styled from 'styled-components'
import { graphql } from 'gatsby'

import Plaatjie from "@ubo/plaatjie"


// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import ParseContent from 'components/shared/ParseContent'
import Review from 'components/Review'
import PriceIndication from 'components/PriceIndication'
import Tabs from 'components/Tabs'
import MobileTabs from 'components/MobileTabs'
import RatingAlt from 'components/Reviews/RatingAlt'

// Elements
import HeroDefault from 'components/elements/HeroDefault'
import ImageBackground from 'components/elements/ImageBackground'
import HeroDescription from 'components/elements/HeroDescription'
import BlockDefault from 'components/elements/BlockDefault'
import ButtonDefault from 'components/elements/ButtonDefault'
import ButtonSecondary from 'components/elements/ButtonSecondary'
import BackgroundDescription from 'components/elements/BackgroundDescription'
import ButtonAlt from 'components/elements/ButtonAlt'

const Intro = styled(BlockDefault)`
  @media (min-width: 992px) {
    margin-top: -150px;

    & h2 {
      font-size: ${(props) => props.theme.font.size.xl};
      font-weight: ${(props) => props.theme.font.weight.s};

      & strong {
        font-weight: ${(props) => props.theme.font.weight.xl};
      }
    }
  }

  @media (max-width: 991px) {
    margin-top: -100px;
  }
`

const FeaturedImage = styled(ImageBackground)`
  padding-top: 50%;
  border-radius: 35px;
  overflow: hidden;
`

const Block = styled(BlockDefault)`
  @media (min-width: 992px) {
    margin-top: -200px;
  }

  @media (max-width: 991px) {
    margin-top: -50px;
  }

  @media (max-width: 575px) {
    margin-top: -35px;
  }
`

const Content = styled(ParseContent)`
  & h1,
  & h2,
  & h3,
  & h4,
  & h5 {
    color: ${(props) => props.theme.color.text.contrast};
  }
`

const HeroBlock = styled(BlockDefault)`
  & h1 {
    font-size: ${(props) => props.theme.font.size['50']};
    line-height: 50px;
    color: ${(props) => props.theme.color.text.contrast};
    text-shadow: none;
  }

  & p {
    color: ${(props) => props.theme.color.text.main};
  }

  & span {
    color: ${(props) => props.theme.color.text.main};
    display: block;
  }

  margin-top: 200px;
`

const HeroTitle = styled(ParseContent)`
  @media (max-width: 991px) {
    & h1 {
      font-size: ${(props) => props.theme.font.size['35']};
      line-height: 40px;
    }
  }
`

const CTA = styled(ParseContent)``

const ButtonSecond = styled(ButtonSecondary)`
  width: 295px;
  text-align: center;

  & a {
    font-size: ${(props) => props.theme.font.size['18']};
  }
`

const ButtonFirst = styled(ButtonDefault)`
  width: 295px;

  & a {
    font-size: ${(props) => props.theme.font.size['18']};
  }
`

const ContentTitle = styled(ParseContent)`
  & h2 {
    font-size: ${(props) => props.theme.font.size['50']};
  }
`

const Box = styled.div`
  background-color: ${props => props.theme.color.contrast};
  border-radius: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 3rem 1rem;

  & span {
    color: ${props => props.theme.color.text.light};
    font-weight: 300;
  }

  @media (max-width: 991px){
    padding: 1rem 1rem 2rem;
  }
`

const InfographicContent = styled(ParseContent)`
  & h2 {
    color: ${props => props.theme.color.text.light};
    font-weight: 800;
    font-size: 30px !important;
    line-height: 49px !important;

    
    @media (max-width: 1198px) {
      font-size: 20px !important;
      line-height: 32px !important;
    }

    @media (min-width: 1199px){
      font-size: 50px;
      line-height: 69px;
    }
    
  }

  & ul {
    list-style: disc;

    & li:before {
        display: none;
    }
  }

  & p, li {
    color: ${props => props.theme.color.text.light};
    font-size: 16px;
    line-height: 30px;
  }
`


const Column = styled.div`
  @media (max-width: 991px){
    max-height: 300px;
  }
`

const StyledButton = styled.a`
  background-color: ${props => props.theme.color.secondary};
  border: 2px solid ${props => props.theme.color.secondary};
  display: inline-flex;
  border-radius: 30px;
  font-weight: ${props => props.theme.font.weight.l};
  color: ${props => props.theme.color.text.light};  

  & > svg {
    margin-left: 15px;

    @media (min-width: 992px) {
      height: 25px;
      width: 25px;
    }

    @media (max-width: 991px) {
      height: 20px;
      width: 20px;
    }
  }

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.color.light};
    border-color: ${props => props.theme.color.light};
    color: ${props => props.theme.color.text.secondary};  
  }

  @media (min-width: 992px) {
    font-size: ${props => props.small ? props.theme.font.size.m : props.theme.font.size.xm};
    padding: 12px 65px;
  }

  @media (max-width: 991px) {
    font-size: ${props => props.small ? props.theme.font.size.m : props.theme.font.size.m};
    padding: 10px 25px;
  }
`

const Image = styled(Plaatjie)`
  & img {
    object-fit: contain !important;
  }
  @media (min-width: 992px){
    margin-top: -12rem;
    margin-left: -4rem;
    height: 450px;
  }

  @media (max-width: 991px){

    display: block;
    margin: 0 auto 2rem;
    overflow: visible;

    & img {
      width: 300px;
      height: auto;
      margin: -2rem auto 2rem;
    }
  }
`

export const pageQuery = graphql`
  query ($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      path
      title

      acf {
        banner {
          title
          description
          cta {
            title
            buttonOne: button_one {
              title
              url
            }
            buttonTwo: button_two {
              title
              url
            }
          }
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 1920)
                openGraph: fluid(maxWidth: 1500, toFormat: JPG) {
                  src
                }
              }
            }
          }
        }

        intro {
          title
        }

        tabs {
          title
          tab_name
          description
          cta {
            title
            button {
              title
              url
            }
          }
        }

        review {
          title
          rating
          description
          background_description
        }

        other_cities {
            related
            background_description
            description
        }

        infographic {
          title
          description
          button {
            title
            localFile {
              publicURL
            }
          }
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 1920)
                openGraph: fluid(maxWidth: 1500, toFormat: JPG) {
                  src
                }
              }
            }
          }
        }
      }

      yoast_meta {
        name
        content
        property
      }
    }
    nations: allWordpressPage(
      limit: 100
      filter: { parent_element: { wordpress_id: { in: [118, 133, 230] } } }
      sort: { fields: menu_order, order: ASC }
    ) {
      edges {
        node {
          wordpress_id
          title
          path
          wpml_current_locale
          acf {
            banner {
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 400)
                  }
                }
              }
            }
          }
        }
      }
    }
  }

`

const PageTemplate = ({
  data: {
    page: { path, yoast_meta: yoast, acf, title },
    nations: { edges: nationsEdges },
  },
}) => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'MovingCompany',
    name: 'Schmidt Global Relocations',
    url: 'https://www.schmidt-global.nl',
    logo: ' https://admin.schmidt-global.nl/wp-content/uploads/2021/05/Schmidt-logo-2019.png',
    telephone: '+31337600270',
    email: 'info@schmidt-global.nl',
    address: {
      '@type': 'PostalAddress',
      streetAddress: ' Stationsweg Oost 281 D',
      addressLocality: 'Woudenberg',
      addressRegion: 'Utrecht',
      postalCode: '3931 ER',
      addressCountry: 'NL',
    },
    openingHours: 'Mo-Fr 09:00-17:30',
    areaServed: [
      {
        '@type': 'Country',
        name: `${title}`,
      },
      {
        '@type': 'Country',
        name: 'Nederland',
      },
    ],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      reviewCount: '732',
    },
    sameAs: [
      'https://www.facebook.com/schmidtglobal',
      'https://www.linkedin.com/company/schmidtglobal',
    ],
  }

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.innerHTML = JSON.stringify(structuredData)
      document.head.appendChild(script)
    }
  }, [structuredData])

  const serviceStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: `Internationaal verhuizen naar ${title}`,
    provider: {
      '@type': 'MovingCompany',
      name: 'Schmidt Global Relocations',
      url: 'https://www.schmidt-global.nl',
    },
    areaServed: [
      {
        '@type': 'Country',
        name: `${title}`,
      },
    ],
    description: `Complete verhuisservice van Nederland naar ${title} , inclusief inpakken, transport, douaneafhandeling en opslagmogelijkheden.`,
  }

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.innerHTML = JSON.stringify(serviceStructuredData)
      document.head.appendChild(script)
    }
  }, [structuredData])

  const reviewStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Review',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      reviewCount: '732',
    },
    review: [
      {
        '@type': 'Review',
        reviewBody: acf.review.description || '',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: acf.review.rating || '5',
          bestRating: '5',
        },
      },
    ],
  }

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.innerHTML = JSON.stringify(reviewStructuredData)
      document.head.appendChild(script)
    }
  }, [reviewStructuredData])
  
  const otherNations = nationsEdges.filter(
    ({ node: { wordpress_id: wpId } }) =>
        acf.other_cities.related.includes(wpId)
  )
  

  return (
    <Layout>
      <SEO
        yoast={yoast}
        path={path}
        image={{
          url:
            acf.banner.image.localFile &&
            acf.banner.image.localFile.childImageSharp.openGraph.src,
        }}
      />

      <section>
        <HeroDefault rounded image={acf.banner.image} big custom overflow>
          <HeroDescription className="d-flex align-items-center justify-content-start h-100">
            <HeroBlock bigBorderRadius className="col-lg-6">
              <HeroTitle content={acf.banner.title} className="mb-4" />
              {acf.banner.description && <ParseContent content={acf.banner.description} className="mb-4" />}
              <CTA content={acf.banner.cta.title} />
              <div className="px-lg-5 d-flex flex-wrap justify-content-center text-center">
                <div>
                  <ButtonFirst type="next" to={acf.banner.cta.buttonOne.url}>
                    {acf.banner.cta.buttonOne.title}
                  </ButtonFirst>
                  <span className="my-2">of</span>
                </div>
                <ButtonSecond to={acf.banner.cta.buttonTwo.url}>
                  {acf.banner.cta.buttonTwo.title}
                </ButtonSecond>
              </div>
            </HeroBlock>
          </HeroDescription>
        </HeroDefault>
      </section>

     <section id="tabInfo" className="pt-5 pt-lg-0">
        <div className="container py-5 ">
          <div className="row pt-5 pb-0 pb-lg-5 mt-5 mt-lg-0">
            <div className="col-12 d-flex justify-content-end px-lg-0">
              <ContentTitle content={acf.intro.title} />
            </div>
          </div>
          <Tabs className="d-none d-lg-flex" fields={acf.tabs} />
          <MobileTabs className="d-lg-none" content={acf.tabs} />
        </div>
      </section>

      {acf.review && (
        <section className="pt-5">
          <div className="container">
            <div className="row flex-wrap-reverse">
              <div className="col-lg-8">
                <BackgroundDescription
                  className="mt-3"
                  content={acf.review.background_description}
                  relative
                />
              </div>
              {/* <div className="col-lg-4">
                <PriceIndication noInfo />
              </div> */}
            </div>
          </div>
          <Review fields={acf.review} />
        </section>
      )}

      <a id="stappenplan" />

      <section>
        <div className="container mb-lg-5 py-5">
          <div className="row">
            <div className="col-lg-7" />
            <div className="col-lg-5">
              <RatingAlt noTitle className="pb-lg-0 pb-4" />
              <div className="mt-4">
                <PriceIndication />
              </div>
            </div>
          </div>
        </div>
      </section>

      

      <section>
        <div className="container my-5" >
        <div className="col-lg-12">
          <Box>
            <Column className="col-lg-4">
              <Image image={acf.infographic.image} alt="Infographic" />
            </Column>
            <div className="col-lg-8">
              <InfographicContent content={acf.infographic.title} />
              <div className="d-flex align-items-center my-3">
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23 3.83332H0V19.1668H23V3.83332Z" fill="#F0F0F0" />
                  <path d="M12.9375 3.83318H10.0625V10.0623H0V12.9373H10.0625V19.1665H12.9375V12.9373H23V10.0623H12.9375V3.83318Z" fill="#D80027" />
                  <path d="M17.6896 14.1665L23 17.1168V14.1665H17.6896Z" fill="#0052B4" />
                  <path d="M14 14.1665L23 19.1665V17.7526L16.545 14.1665H14Z" fill="#0052B4" />
                  <path d="M20.6027 19.1665L14 15.498V19.1665H20.6027Z" fill="#0052B4" />
                  <path d="M14 14.1665L23 19.1665V17.7526L16.545 14.1665H14Z" fill="#F0F0F0" />
                  <path d="M14 14.1665L23 19.1665V17.7526L16.545 14.1665H14Z" fill="#D80027" />
                  <path d="M4.05829 14.1664L0 16.421V14.1664H4.05829Z" fill="#0052B4" />
                  <path d="M9.00002 14.8022V19.1664H1.14511L9.00002 14.8022Z" fill="#0052B4" />
                  <path d="M6.45496 14.1665L0 17.7526V19.1665L9.00001 14.1665H6.45496Z" fill="#D80027" />
                  <path d="M5.31044 8.83317L0 5.88288V8.83317H5.31044Z" fill="#0052B4" />
                  <path d="M9.00001 8.83317L0 3.83318V5.24705L6.45496 8.83317H9.00001Z" fill="#0052B4" />
                  <path d="M2.39731 3.83318L9.00002 7.50168V3.83318H2.39731Z" fill="#0052B4" />
                  <path d="M9.00001 8.83317L0 3.83318V5.24705L6.45496 8.83317H9.00001Z" fill="#F0F0F0" />
                  <path d="M9.00001 8.83317L0 3.83318V5.24705L6.45496 8.83317H9.00001Z" fill="#D80027" />
                  <path d="M18.9417 8.83326L23 6.57863V8.83326H18.9417Z" fill="#0052B4" />
                  <path d="M14 8.19743V3.83323H21.8549L14 8.19743Z" fill="#0052B4" />
                  <path d="M16.545 8.83317L23 5.24705V3.83318L14 8.83317H16.545Z" fill="#D80027" />
                </svg>
                <span className="pl-2">Engelstalig</span>
              </div>
              <InfographicContent content={acf.infographic.description} className="pr-md-5 mb-4" />
              <StyledButton href={acf.infographic.button.localFile.publicURL} target="_blank" rel="noopener noreferrer" className="justify-content-center text-center">Download nu</StyledButton>
            </div>
          </Box>
        </div>
      </div>
    </section>

      {acf.other_cities && acf.other_cities.related && acf.other_cities.related.length > 0 && (
        <section className='mt-5'>
          <div className='mt-lg-5 pt-lg-5 container mb-lg-5 pb-5'>
            {acf.other_cities.background_description && (
              <BackgroundDescription
                content={acf.other_cities.background_description}
                relative
              />
            )}
            {acf.other_cities.description && (
              <ParseContent className='mb-4 mt-2 px-lg-2' content={acf.other_cities.description} />
            )}
            <div className='d-flex flex-wrap flex-lg-nowrap'>
              {otherNations.map(({ node }) => (
                <Nation key={node.wordpress_id} title={node.title.replace('Verhuizen naar ', '')} path={node.path} image={node.acf.banner.image} />
              ))}
            </div>
          </div>
        </section>
      )}
    </Layout>
  )
}

const Thumbnail = styled(Plaatjie)`
  border-radius: 15px;
  overflow: hidden;
  z-index: 1;
  height: 230px;
  display: block !important;
`

const NationContent = styled.div`
  z-index: 2;
`

const Nation = ({ title, path, image }) =>  (
    <div className="col-md-4 mb-5">
      <Thumbnail image={image} alt={title} />
      <NationContent className="text-center mt-n4 position-relative">
      <ButtonAlt to={path} type="next">
          {title}
      </ButtonAlt>
      </NationContent>
    </div>    
)

export default PageTemplate
